export default "__VITE_ASSET__a1c75141__"